
export const DeleteIcon = (props: React.SVGProps<SVGSVGElement>) => {
  props = {
    ...props,
    color: props.color,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12.4}
      height={12.4}
      viewBox="0 0 12.4 12.4"
      {...props}
    >
      <path
        d="M22.084,21.608l-.476.476,5.724,5.724-5.724,5.724.476.476,5.724-5.724,5.724,5.724.476-.476-5.724-5.724,5.724-5.724-.476-.476-5.724,5.724Z"
        transform="translate(-21.608 -21.608)"
        fill="currentColor"
      />
    </svg>
  );
};
